import saveDataSource from './saveDataSource'
import deleteDataSource from './deleteDataSource'

export const saveDataSourcePromise = saveDataSource
export const deleteDataSourcePromise = deleteDataSource
